import React, { useState } from "react";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import IconButton from "@mui/material/IconButton";
import DialogImportTemplate from "../dialogs/DialogImportTemplate";
import { CalculateStaticAnalysisWithPeriod } from "../operations/AnalysisOperations";
import { useSnackbar } from "notistack";
import { gapi } from "gapi-script";
import Snackbar from "@mui/material/Snackbar";
import Alert from '@mui/material/Alert';
import Tooltip from "@mui/material/Tooltip";
import loadGoogleClient from "./LoadGoogleClient";


import { useProjectStore } from "../model/ProjectStore";

const createImportTemplateSheet = (project, period, enqueueSnackbar) => {
  let date = new Date();
  let newFileName =
    project.name + " Import Sheet for period: " + period +
    date.toLocaleTimeString() +
    (date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate());

  createSheet(enqueueSnackbar, newFileName, (response) => {
    populateImportSpreadSheet(project, period, response.result.spreadsheetId, enqueueSnackbar);
  });
};

const populateImportSpreadSheet = (project, period, spreadsheetId, enqueueSnackbar) => {
  const headers = ["Code", "Name", "Period", "Progress", "Cost"];
  let values = [headers]
  let rootTask = project.rootTaskPackage;
  let count = 1;
  const extractValues = (taskPackage) => {
    values[count++] = itemToRow(taskPackage, period);
    taskPackage.taskPackages.forEach(element =>
      extractValues(element)
    );
    taskPackage.tasks.forEach(element =>
      values[count++] = itemToRow(element, period)
    );

  };
  extractValues(rootTask);
  const body = {
    values: values,
  };
  try {
    gapi.client.sheets.spreadsheets.values
      .update({
        spreadsheetId: spreadsheetId,
        range: "A1:F",
        valueInputOption: "USER_ENTERED",
        resource: body,
      })
      .then((response) => {
        enqueueSnackbar(`Spreadsheet template created and opened in a new tab!`, {
          variant: "success",
        });
      });
  } catch (err) {
    enqueueSnackbar(err.message, { variant: "error" });
    return;
  }
}

const itemToRow = (item, period) => {
  let row = [];
  row[0] = item.code;
  row[1] = item.name;
  row[2] = period;
  row[3] = 0;
  row[4] = 0;
  return row;
}

const findSpreadsheetID = (
  newFileName,
  name_spreadsheetID_ToFind,
  valueToBeWritten,
  resultHandler,
  sheetCreated,
  enqueueSnackbar
) => {
  try {
    gapi.client.drive.files
      .list({
        q:
          "mimeType = 'application/vnd.google-apps.spreadsheet' and name = '" +
          name_spreadsheetID_ToFind +
          "'",
      })
      .then((response) => {
        resultHandler(
          newFileName,
          response.result.files[0].id,
          valueToBeWritten,
          sheetCreated,
          enqueueSnackbar
        );
      });
  } catch (err) {
    enqueueSnackbar(err.message, { variant: "error" });
    return;
  }
};

const createSheet = (enqueueSnackbar, title, callback) => {
  try {
    gapi.client.sheets.spreadsheets.create({
      properties: {
        title: title,
      },
    }).then((response) => {
      if (callback) callback(response);
      console.log('Spreadsheet ID: ' + response.result.spreadsheetId);
      let urlString =
          `https://docs.google.com/spreadsheets/d/` +
          response.result.spreadsheetId +
          `/edit#gid=0`;
      window.open(urlString, '_blank');
    });
  } catch (err) {
    console.log(err.message);
    //document.getElementById('content').innerText = err.message;
    return;
  }
};

const styleIndividualRow = (
  spreadsheetId,
  requests,
  resultHandler,
  enqueueSnackbar
) => {
  try {
    const batchUpdateRequest = { requests: requests };
    gapi.client.sheets.spreadsheets
      .batchUpdate({
        spreadsheetId: spreadsheetId,
        resource: batchUpdateRequest,
      })
      .then(() => {
        resultHandler(spreadsheetId, autoResizeRows, enqueueSnackbar);
      });
  } catch (err) {
    enqueueSnackbar(err.message, { variant: "error" });
    return;
  }
};

const autoResizeColumns = (spreadsheetId, resultHandler, enqueueSnackbar) => {
  const requests = [];
  requests.push({
    autoResizeDimensions: {
      dimensions: {
        sheetId: 0,
        dimension: "COLUMNS",
      },
    },
  });
  try {
    const batchUpdateRequest = { requests: requests };
    gapi.client.sheets.spreadsheets
      .batchUpdate({
        spreadsheetId: spreadsheetId,
        resource: batchUpdateRequest,
      })
      .then(() => {
        resultHandler(spreadsheetId, enqueueSnackbar);
      });
  } catch (err) {
    enqueueSnackbar(err.message, { variant: "error" });
    return;
  }
};

const autoResizeRows = (spreadsheetId, enqueueSnackbar) => {
  const requests = [];
  requests.push({
    autoResizeDimensions: {
      dimensions: {
        sheetId: 0,
        dimension: "ROWS",
      },
    },
  });
  try {
    const batchUpdateRequest = { requests: requests };
    gapi.client.sheets.spreadsheets
      .batchUpdate({
        spreadsheetId: spreadsheetId,
        resource: batchUpdateRequest,
      })
      .then(() => {
        let urlString =
          `https://docs.google.com/spreadsheets/d/` +
          spreadsheetId +
          `/edit#gid=0`;

      });
  } catch (err) {
    enqueueSnackbar(err.message, { variant: "error" });
    return;
  }
};

function CreateImportTemplate() {
  const project = useProjectStore();
  const [createSheetStarted, setCreateSheetStarted] = useState(false);
  const [createSheetCompleted, setCreateSheetCompleted] = useState(false);

  const [exportEvaOpen, setExportEvaOpen] = useState(false);
  const { enqueueSnackbar } = useSnackbar();


  const handleCreate = () => {
    setExportEvaOpen(true);
  };

  const handleExportEVAClose = () => {
    setExportEvaOpen(false);
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setCreateSheetStarted(false);
    setCreateSheetCompleted(false);
  };

  const generateSpreadsheet = (period) => {
    if (period == null) {
      return;
    }
    createImportTemplateSheet(project,
      period,
      enqueueSnackbar);
    setExportEvaOpen(false);
  };

  return (
    <div className="AddGoogleSheetButton">
      <Tooltip title="Create Import Template" aria-label="Create Import Template on GoogleSheets">
        <IconButton onClick={() => handleCreate()} color="inherit">
          <NoteAddIcon />
        </IconButton>
      </Tooltip>
      <DialogImportTemplate
        open={exportEvaOpen}
        onCancel={handleExportEVAClose}
        onSave={(period) => loadGoogleClient(() => generateSpreadsheet(period))}
      />
      <Snackbar
        title="Create Spreadsheet Start"
        open={createSheetStarted}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="info"
          sx={{ width: "100%" }}
        >
          Creating Spreadsheet for Import...
        </Alert>
      </Snackbar>
      <Snackbar
        title="Create Spreadsheet End"
        open={createSheetCompleted}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="success"
          sx={{ width: "100%" }}
        >
          Successfully Created the Spreadsheet
        </Alert>
      </Snackbar>
    </div>
  );
}

export default CreateImportTemplate;
